export default function Hero() {
  return (
    <section className="bg-gradient-to-b from-green-50 to-white py-20">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center">
          <div className="mb-8">
            <h2 
              className="text-5xl md:text-6xl font-bold text-gray-800 mb-6"
              style={{ fontFamily: '"Noto Serif JP", serif' }}
            >
              誠実な営業代行で<br />
              お客様のビジネスを支えます
            </h2>
            <div className="w-24 h-1 bg-green-600 mx-auto mb-8"></div>
            <p 
              className="text-xl text-gray-600 leading-relaxed"
              style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
            >
              合同会社Natureは、神奈川県横須賀市を拠点に<br />
              営業代行業務を通じてお客様のビジネスパートナーとして貢献いたします
            </p>
          </div>

          <div className="mt-12">
            <a 
              href="#contact"
              className="inline-block bg-green-700 text-white px-12 py-4 text-lg font-medium hover:bg-green-800 transition-colors whitespace-nowrap"
              style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
            >
              お問い合わせはこちら
            </a>
          </div>

          <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-6 border border-gray-300">
              <div className="w-16 h-16 bg-green-100 mx-auto mb-4 flex items-center justify-center">
                <i className="ri-shield-check-line text-3xl text-green-700"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-800 mb-2" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                信頼と実績
              </h3>
              <p className="text-sm text-gray-600" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                誠実な対応で信頼関係を築きます
              </p>
            </div>

            <div className="bg-white p-6 border border-gray-300">
              <div className="w-16 h-16 bg-green-100 mx-auto mb-4 flex items-center justify-center">
                <i className="ri-team-line text-3xl text-green-700"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-800 mb-2" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                専門性
              </h3>
              <p className="text-sm text-gray-600" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                営業のプロフェッショナルが対応
              </p>
            </div>

            <div className="bg-white p-6 border border-gray-300">
              <div className="w-16 h-16 bg-green-100 mx-auto mb-4 flex items-center justify-center">
                <i className="ri-line-chart-line text-3xl text-green-700"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-800 mb-2" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                成果重視
              </h3>
              <p className="text-sm text-gray-600" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                結果にこだわったサービス提供
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}